import axios from 'axios';
import { getToken, clearToken } from './tokenStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Helper function to get secure redirect URL
export const getSecureRedirectUrl = (path = '/dashboard') => {
  let url = window.location.origin + path;
  // Force HTTPS for production (non-localhost)
  if (!url.includes('localhost') && url.startsWith('http://')) {
    url = url.replace('http://', 'https://');
  }
  return url;
};

// Helper function to redirect to the app's own login page
export const redirectToAuth = (returnPath = '/dashboard') => {
  window.location.href = `/login?redirect=${encodeURIComponent(returnPath)}`;
};

const apiClient = axios.create({
  baseURL: API,
  withCredentials: false, // Using Bearer token auth, not cookies
  timeout: 30000, // 30 second timeout
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor with improved error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized - let ProtectedRoute handle redirects
    if (error.response?.status === 401) {
      clearToken();
    }
    
    // Handle 429 Rate Limit
    if (error.response?.status === 429) {
      error.message = 'Too many requests. Please wait a moment and try again.';
    }
    
    // Handle 500 Server Error
    if (error.response?.status >= 500) {
      error.message = 'Server error. Please try again later.';
    }
    
    // Handle network errors - don't override if it's just a timeout
    if (!error.response && error.code !== 'ECONNABORTED') {
      error.message = 'Connection issue. Retrying...';
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
